import { createAction, createRequestActions } from "common/helpers/action";

export const initKkmGroupTransactionList = createRequestActions("KKM_GROUP.TRANSACTION_LIST.INIT");
export const scrollKkmGroupTransactionList = createRequestActions("KKM_GROUP.TRANSACTION_LIST.SCROLL");
export const searchKkmGroupTransactionList = createRequestActions("KKM_GROUP.TRANSACTION_LIST.SEARCH");
export const filterKkmGroupTransactionList = createRequestActions("KKM_GROUP.TRANSACTION_LIST.FILTER");
export const sortKkmGroupTransactionList = createRequestActions("KKM_GROUP.TRANSACTION_LIST.SORT");

export const showDetailKkmGroupTransactionList = createAction("KKM_GROUP.TRANSACTION_LIST.SHOW_DETAIL");
